import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
// utils
import localStorageAvailable from '../utils/minimal/localStorageAvailable';
// components
import { useSettingsContext } from '../components/minimal/settings';
//
import { allLangs, defaultLang } from './config-lang';
import { getI18nLocalStorageValue, getI18nLocalStorageKey } from './utils';

// ----------------------------------------------------------------------

export default function useLocales() {
  const { i18n, t: translate } = useTranslation();

  const { onChangeDirectionByLang } = useSettingsContext();

  const storageAvailable = localStorageAvailable();

  // Check for lang parameter in URL on each render
  const urlParams = new URLSearchParams(window.location.search);
  const langFromUrl = urlParams.get('lang');

  // Handle URL parameter changes dynamically
  useEffect(() => {
    if (langFromUrl && ['en', 'he'].includes(langFromUrl) && i18n.language !== langFromUrl) {
      i18n.changeLanguage(langFromUrl);
      onChangeDirectionByLang(langFromUrl);
      // Save the language from URL to localStorage for future visits
      if (storageAvailable) {
        localStorage.setItem(getI18nLocalStorageKey(), langFromUrl);
      }
    }
  }, [langFromUrl, i18n, onChangeDirectionByLang, storageAvailable]);

  const langStorage = storageAvailable ? getI18nLocalStorageValue() : '';

  const currentLang = allLangs.find((_lang) => _lang.value === langStorage) || defaultLang;

  const handleChangeLanguage = (newlang) => {
    i18n.changeLanguage(newlang);
    onChangeDirectionByLang(newlang);
  };

  return {
    onChangeLang: handleChangeLanguage,
    translate: (text, options) => translate(text, options),
    currentLang,
    allLangs,
  };
}
